<template>
  <div>
    <Head title="會員回饋機制" />
    <ScrollTop />

    <div class="w-full mt-5">
      <figure class="my-16">
        <img src="/images/giveBack01.jpg" />
      </figure>

      <h1 class="text-center">FOODY HOME 網站會員回饋機制</h1>
      <br />
      <br />
      <h2>壹．通則:</h2>
      <br />
      <ul>
        <li>
          <p>
            1.所有C.V.給予皆建立於網站內購買商品之消費，單筆消費的C.V.發放兩份，
            一份給予消費帳號本身，一份給予該消費帳號註冊網站時，使用之推薦碼帳號(即推薦帳號)，
            如無推薦帳號，則僅發放一份給消費帳號本身。
          </p>
          <img class="w-3/4 md:w-1/2" src="/images/cv.jpg" alt="" />
        </li>

        <li>
          <p>
            2.網站購物金及推廣獎勵金之計算週期為本月十六號至次月十五號，
            該期間內已確認完成所有流程(下單-付款-出貨-運輸-收貨-確認無退換貨)之訂單，
            並統一於次月二十五號發放，如遇假日則順延至下一工作日。
          </p>
        </li>
        <li>
          <p>
            3.C.V.値說明:<br />
            C.V.値為custmer value之縮寫，意即消費者價値。
            本網站內之商品除售價以外，亦會訂定一C.V.値。
            網站商品總體售價與總體C.V.値的比例，將平均在100:70-75，確保回饋機制具公信力。
            C.V.値無法轉給其他帳號。
          </p>
        </li>
        <li>
          <p>
            4.為避免會員帳號浮濫申請，一手機號碼僅提供申請一會員帳號，以電話號碼作為帳號綁定依歸。
            會員帳號不得買賣交易過戶，違者註銷帳號，並將該帳號登錄之手機電話號碼列入黑名單，
            未來不再接受該組電話號碼之註冊。
          </p>
        </li>
      </ul>
      <h2>貳．一般會員:</h2>
      <br />
      <p>
        一般會員可用自己的推薦碼，推薦朋友加入FOODY HOME。<br />
        被推薦人加入後的消費會提供一份C.V.給予推薦人。<br />
        一般會員於計算周期內所得的C.V.値，經一般會員C.V.級距計算後，獲得網站購物金。<br />
      </p>
      <img class="w-3/4 md:w-1/3" src="/images/shopping_gold.jpg" alt="" />
      <ul>
        <li>
          <p>
            1.一般會員模型:<br />
            A為一般會員；B、C、D為經由A推薦碼加入之會員。
            (C.V.A為該週期，A自己消費獲得之C.V.値;
            C.V.B為該週期，B自己消費獲得之C.V.値，以此類推。)
          </p>
          <br />
          <p>
            A 於每一計算週期可得 C.V.A+C.V.B+C.V.C+C.V.D=C.V.TA<br />
            C.V.TA × 一般會員級距計算比例 = M.V.A<br />
            M.V.A 於 A 為一般會員時即為網站購物金。
          </p>
          <img class="w-3/4 md:w-1/2" src="/images/cvta.jpg" alt="" />
        </li>
        <li>
          <p>2.一般會員C.V.級距計算比例</p>
          <img class="w-3/4 md:w-1/3" src="/images/normal_par_tb.jpg" alt="" />
        </li>
        <!-- <table>
            <thead>
                <tr>
                    <th>計算週期內之 C.V.TA</th>
                    <th>計算比例</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>0 - 50000</td>
                    <td>50001 以上</td>
                </tr>
                <tr>
                    <td>1%</td>
                    <td>2%</td>
                </tr>
            </tbody>
        </table> -->
        <li>
          <p>
            3.一般會員之購物金有效期限為發放日起三個月，超過期限將自動失效。
          </p>
        </li>
        <li>
          <p>
            4.購物金不得轉讓給其他會員或是轉為現金。
            如有退貨之狀況，則購物金將自動退回消費帳號，沿用購物金之原本效期。
          </p>
        </li>
        <li>
          <p>
            5.購物金之使用:<br />
            購物金抵用時，將一併扣抵該筆訂單之C.V.。<br />
            購物金之使用在訂單完成運費計算後折抵。<br />
            舉例:購買一訂單，運費計算後原價金額為2000元，C.V.為1500。
            使用購物金折抵150，則訂單金額為1850元，所得C.V.為1350。<br />
          </p>
        </li>
      </ul>
      <h2>參．推廣會員:</h2>
      <br />
      <p>
        推廣會員係提供認同本網站概念之一般會員，推廣網站邀請朋友加入，並獲得推廣獎勵金。
        在滿足申請條件後，審閱並簽定相關合約，繳交須備資料提出申請，經公司審核通過即
        為推廣會員。推廣會員如同一般會員，可用自己的推薦碼，推薦朋友加入FOODY
        HOME。
        推廣會員於計算周期內所得的C.V.値，經推廣會員C.V.級距計算後，獲得推廣獎勵金之現金回饋。
      </p>
      <ul>
        <li>
          <h3>1.推廣會員模型:<br /></h3>
          <p>
            A為推廣會員；B、C、D為經由A推薦碼加入之會員。<br />
            A於每一計算週期可得C.V.A+C.V.B+C.V.C+C.V.D=C.V.TA<br />
            C.V.TA×一般會員級距計算比例=M.V.A<br />
            M.V.A於A為推廣會員時即為現金回饋。<br />
          </p>
          <img class="w-3/4 md:w-1/3" src="/images/give_back.jpg" alt="" />
        </li>
        <li>
          <h3>2.推廣會員 C.V.級距計算比例:<br /></h3>
          <img class="w-3/4 md:w-1/3" src="/images/vip_par_tb.jpg" alt="" />
          <!-- <table>
                <thead>
                    <tr>
                        <th>計算週期內之 C.V.TA</th>
                        <th>計算比例</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>0-100000</td>
                        <td>2%</td>
                    </tr>
                    <tr>
                        <td>100001-250000</td>
                        <td>3%</td>
                    </tr>
                    <tr>
                        <td>250001-500000</td>
                        <td>4%</td>
                    </tr>
                    <tr>
                        <td>500001 以上</td>
                        <td>5%</td>
                    </tr>
                </tbody>
            </table> -->
        </li>

        <li>
          <h3>3.推廣會員申請資格:<br /></h3>
          <p>
            (1)經由帳號之推薦碼加入會員人數累計達 30 人。<br />
            (2)任連續十二個完整計算週期內，帳號之C.V.T累計達100000。<br />
            上述達成其中一項條件，即可向本公司提出申請。
          </p>
        </li>
        <li>
          <h3>4.推廣會員申請應備資料:<br /></h3>
          <p>
            (1)推廣會員條款同意書。<br />
            (2)身分證正反面影本。<br />
            (3)匯款存摺封面影本。
          </p>
        </li>
        <li>
          <h3>5.推廣會員資格維持條件:<br /></h3>
          <p>
            任連續三個完整計算週期內，分潤帳號須達成下列條件任選一項:<br />
            (1)在網站上消費取得C.V.値累計達1500C.V.。<br />
            舉例:A在07/01正式升級為推廣會員，則A須從07/16-08/15這個計算週期開始，
            連同08/16-09/15、09/16-10/15，這連續三個計算週期內，自己帳號消費取得累計達1500C.V.
            而下一任連續三個完整計算週期為08/16-09/15、09/16-10/15、10/16-11/15。
          </p>
          <p>
            (2)推薦碼介紹新加入2個會員以上<br />
            舉例:A在06/25正式升級為推廣會員，則A須從07/16-08/15這個計算週期開始，
            連同08/16-09/15、09/16-10/15，這連續三個計算週期內，
            自己帳號推薦碼介紹新加入會員累計達2個以上。
            而下一任連續三個完整計算週期為08/16-09/15、09/16-10/15、10/16-11/15。
          </p>
          <br />
          <p>
            如無法達成資格維持條件，將於下一計算週期開始降為一般會員，所有權益及計算方式
            依照一般會員模式。任連續三個完整計算週期中的最後一個完整計算週期開始時，
            如推廣會員資格維持條件未達成任一項，系統將發送Email提醒通知。
          </p>
        </li>
        <li>
          <h3>
            6.推廣會員降級一般會員欲恢復推廣會員資格，可由下列其中一種方式:<br />
          </h3>
          <p>
            (1)降為一般會員後，帳號推薦碼再介紹新加入會員累計達10個。<br />
            (2)降為一般會員後，任連續十二個完整計算週期內，帳號之C.V.T累計達100000。<br />
            由於曾具有推廣會員資格，達成上述其中一種條件，系統將自動將帳號資格升級為推廣會員。
          </p>
        </li>
        <li>
          <h3>7.推廣獎勵金發放:</h3>
          <p>
            (1)統一於每月二十五號匯入提供之存摺帳戶，如遇假日則順延至下一工作日。<br />
            (2)每一筆推廣獎勵金發放須扣除三十元轉帳作業處理費。<br />
            (3)推廣獎勵金發放最低須達新台幣一百元以上，如未達，則累計至超過新台幣一百元時發放。<br />
            如降級為一般會員時，有未發放之推廣獎勵金，
            該未發放之推廣獎勵金將乘以兩倍轉為網站購物金，存入網站購物金帳戶。
          </p>
          <p>
            舉例一:A為推廣會員，於07/16-08/15計算週期可得推廣獎勵金60元，由於未達100，
            累計至帳號推廣獎勵金帳戶，該期不予發放。於08/16-09/15計算週期可得分潤金70元，
            則該期可得推廣獎勵金:帳戶內推廣獎勵金60+當期推廣獎勵金70元=130元，
            扣除30元轉帳作業處理費後，實際收到100元。
          </p>
          <p>
            舉例二:A為推廣會員，於07/16降級為一般會員，06/16-07/15計算週期可得推廣獎勵金20元，
            帳號推廣獎勵金帳戶內有40元未發放推廣獎勵金，將於07/25發放(20+40)×2=120的網站購物金。
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import ScrollTop from "primevue/scrolltop";

export default {
  components: { ScrollTop },
  layout: Layout,
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  },
};
</script>

<style scoped>
/* HTML5 display-role reset for older browsers */
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

li {
  margin-top: 2rem;
  margin-bottom: 2rem;
  line-height: 2;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table,
th,
td {
  border: 1px solid rgb(0, 0, 0);
  padding: 0.5rem;
  text-align: left;
  width: 24em;
}

* {
  font-family: "Noto Sans TC", sans-serif;
}

p {
  font-size: 1.25rem;
  line-height: 2;
  color: rgb(122, 119, 116);
}

h1 {
  font-size: 2.25rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h2 {
  font-size: 1.875rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h3 {
  font-size: 1.5rem;
  margin: 0.67rem 0;
  font-weight: 700;
}
</style>